var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/**
 * Allow writing cookies and reading either the current value, or an existing cookie on
 * the request.
 *
 * @class CurrentCookie
 */
var CurrentCookie = /** @class */ (function () {
    /**
     * Creates an instance of CurrentCookie for `request` and `response`
     *
     * @param {any} request
     * @param {any} response
     */
    function CurrentCookie(request, response) {
        this.response = response;
        this.request = request;
        this.newCookies = {};
        this.codecs = {};
    }
    Object.defineProperty(CurrentCookie.prototype, "cookies", {
        get: function () {
            var _this = this;
            var allCookies = Object.assign({});
            var allKeys = __spreadArrays(Object.keys(this.request.cookies), Object.keys(this.newCookies)).filter(function (k) { return !_this.newCookies[k] || _this.newCookies[k].value !== undefined; });
            allKeys.forEach(function (key) {
                allCookies[key] = _this.get(key);
            });
            return allCookies;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Set the cookie
     *
     * @param {string} key
     * @param {string} value
     */
    CurrentCookie.prototype.set = function (key, obj) {
        var codec = this.codecs[key];
        var value = codec ? codec.encode(obj) : ensureString(obj);
        this.newCookies[key] = { value: value };
        this.response.cookie(key, value);
    };
    /**
     * Get the cookie
     *
     * @param {string} key
     * @returns
     */
    CurrentCookie.prototype.get = function (key) {
        var local = this.newCookies[key];
        var value = (local ? local.value : (this.request.cookies || {})[key]);
        var codec = this.codecs[key];
        return codec ? codec.decode(value) : value;
    };
    /**
     * clear a cookie
     *
     * @param {string} key
     */
    CurrentCookie.prototype.clear = function (key) {
        this.newCookies[key] = { value: undefined };
        this.response.clearCookie(key);
    };
    CurrentCookie.prototype.setEncoders = function (key, encode, decode) {
        this.codecs[key] = { encode: encode, decode: decode };
    };
    return CurrentCookie;
}());
export default CurrentCookie;
function ensureString(obj) {
    if (typeof obj !== 'string') {
        throw new Error('Cookies can only be set for string values. Use an encoder, or convert it yourself');
    }
    return obj;
}
//# sourceMappingURL=current-cookie.js.map